import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_3 = { class: "px-6 py-6" }
const _hoisted_4 = { class: "bg-gray-50 dark:bg-black rounded-lg p-4 space-y-2 mb-4" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_9 = { class: "flex justify-between" }
const _hoisted_10 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}

import { ref, watch } from 'vue';
import type { Claim } from '@/types/claim';


export default /*@__PURE__*/_defineComponent({
  __name: 'RejectClaimModal',
  props: {
    isOpen: { type: Boolean },
    claim: {},
    loading: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const rejectionReason = ref('');

// Reset rejection reason when modal closes
watch(() => props.isOpen, (newValue) => {
  if (!newValue) {
    rejectionReason.value = '';
  }
});

function handleClose() {
  rejectionReason.value = '';
  emit('close');
}

function handleConfirm() {
  emit('confirm', rejectionReason.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.claim)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800 px-6 py-4 flex items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mr-3" }, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-6 w-6 text-red-600 dark:text-red-400",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ])
                    ]),
                    _createElementVNode("h3", { class: "text-lg font-semibold text-red-900 dark:text-red-100" }, " Reject Claim ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-gray-700 dark:text-gray-300 mb-4" }, " Are you sure you want to reject this claim? ", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Claim Number:", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.claim.claim_number), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Customer:", -1)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.claim.user?.first_name) + " " + _toDisplayString(_ctx.claim.user?.last_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm text-gray-500 dark:text-gray-400" }, "Tire:", -1)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.claim.tire?.pattern) + " - " + _toDisplayString(_ctx.claim.tire?.tire_size), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "rejection-reason",
                        class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                      }, " Rejection Reason (Optional) ", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "rejection-reason",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rejectionReason).value = $event)),
                        rows: "4",
                        class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring",
                        placeholder: "Enter the reason for rejecting this claim..."
                      }, null, 512), [
                        [_vModelText, rejectionReason.value]
                      ])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4" }, [
                      _createElementVNode("p", { class: "text-sm text-red-800 dark:text-red-300" }, [
                        _createElementVNode("strong", null, "Warning:"),
                        _createTextVNode(" This action will mark the claim as rejected and notify the customer. ")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      onClick: handleClose,
                      disabled: _ctx.loading,
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancel ", 8, _hoisted_13),
                    _createElementVNode("button", {
                      onClick: handleConfirm,
                      disabled: _ctx.loading,
                      class: "px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[8] || (_cache[8] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[9] || (_cache[9] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M6 18L18 6M6 6l12 12"
                            }, null, -1)
                          ]))),
                      _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Rejecting...' : 'Reject Claim'), 1)
                    ], 8, _hoisted_14)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})